// Properties of a record's card (stage Q, um/2026-10-30/02, R-U6): two or three are seen, the rest wait under «Показать ещё N».
// One rule for every type: the section's eye decides; where it is not set, the first filled fields are the main ones.

import type { FieldDef } from './model.ts';

/** How many fields the card shows at once when the section has not chosen. */
export const CARD_MAIN_DEFAULT = 3;

const filled = (v: unknown) => v != null && v !== '' && !(Array.isArray(v) && !v.length);

/**
 * Splits the property fields of a record into the seen and the hidden ones. A field with the eye on is seen even empty — the section
 * chose it to be filled; with the eye off it is hidden. The rest fill the free places, filled only: required first, then the columns
 * of the section's first view (`prefer` — what the app already called the main fields), then the field order.
 */
export function cardSplit(fields: FieldDef[], data: Record<string, unknown>, prefer: string[] = [], slots = CARD_MAIN_DEFAULT): { main: FieldDef[]; more: FieldDef[] } {
  const chosen = new Set(fields.filter((f) => f.card === 'main'));
  const rank = (f: FieldDef) => { const i = prefer.indexOf(f.key); return (f.required ? 0 : 1000) + (i < 0 ? 500 + f.order : i); };
  const free = fields.filter((f) => !f.card && filled(data[f.key])).sort((a, b) => rank(a) - rank(b));
  const auto = free.slice(0, Math.max(0, slots - chosen.size));
  const main = new Set([...chosen, ...auto]);
  return { main: fields.filter((f) => main.has(f)), more: fields.filter((f) => !main.has(f)) };
}

/** What the eye of a field shows in the settings: the section's choice, or what the card does by itself. */
export const cardEye = (f: FieldDef): 'main' | 'more' | 'auto' => f.card ?? 'auto';
